import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';
import type {
  DeletePrivateNotifBody,
  DeletePrivateNotifResponse,
  GenerateCentrifugoTokenData,
  GetNotifBody,
  GetNotifResultData,
  ReadNotifBody,
  ReadNotifResponse
} from './types/inappApiTypes';
import type { ApiResponse } from '@/app/common/types/common';

const inappApi = createApi({
  reducerPath: 'inappApi',
  baseQuery: (...args) => customFetchBase(getBaseApiPath(), ...args),
  endpoints: build => ({
    deletePrivateNotif: build.mutation<
      DeletePrivateNotifResponse,
      DeletePrivateNotifBody
    >({
      query: body => ({
        url: `/notif_binesh/v1/in_app/mizfa_tools/delete_private_notif`,
        method: 'POST',
        body
      })
    }),
    readNotif: build.mutation<ReadNotifResponse, ReadNotifBody>({
      query: body => ({
        url: `/notif_binesh/v1/in_app/mizfa_tools/read_notif`,
        method: 'POST',
        body
      })
    }),
    getNotif: build.query<GetNotifResultData, GetNotifBody>({
      query: body => ({
        url: `/notif_binesh/v1/in_app/get_notif_v2`,
        method: 'POST',
        body
      }),
      transformResponse: (response: ApiResponse<GetNotifResultData>) =>
        response.data
    }),
    getCentrifugoToken: build.query<
      GenerateCentrifugoTokenData,
      string | void
    >({
      query: () => ({
        url: `/notif_binesh/v1/in_app/mizfa_tools/generate_token`,
        method: 'POST'
      }),
      transformResponse: (response: ApiResponse<GenerateCentrifugoTokenData>) =>
        response.data
    })
  })
});

export const {
  useDeletePrivateNotifMutation,
  useReadNotifMutation,
  useLazyGetNotifQuery,
  useLazyGetCentrifugoTokenQuery
} = inappApi;

export default inappApi;
